import { render, staticRenderFns } from "./ProductPackageEdit.vue?vue&type=template&id=3d86c35a&"
import script from "./ProductPackageEdit.vue?vue&type=script&lang=js&"
export * from "./ProductPackageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports